<template>
  <div class="is_headapp">
    <h1>Первичная приёмка</h1>
    <pre v-if="0">
      {{list}}
    </pre>
    <template v-if="success">
      <p style="font-weight: bold; color: green;">Статус заказа успешно изменён</p>
    </template>
    <template v-else>
        <v-text-field 
          v-model="value"
          autofocus
          @keyup.enter="check_code"
          label="Введите код"
        />
        
          <template v-if="list.length">
            <table class="tbl1">
              <tr class="h">
                <td><b>Найденный объект</b></td>
                <td>&nbsp;</td>
              </tr>
              <tr v-for="(l,idx) in list">
                <template v-if="l.type=='order'">
                  <td>Заявка №{{l.order_id}}</td>
                  
                </template>
                <template v-else-if="l.type=='box'">
                  <td>Место №{{l.num_place}} заявки №{{l.order_id}}</td>
                  
                </template>
                <td class="actions"><a href="" @click.prevent="delete_from_list(idx)"><v-icon small  color="primary" icon >delete</v-icon></a></td>
              </tr>
            </table>
            <div style="margin-top: 20px;">
              <v-btn @click="accept_all()">Принять</v-btn>
            </div>
            <p v-if="accept_all_error" style="font-weight: bold; color: red">{{accept_all_error}}</p> <!-- ошибка при подтверждении -->
          </template>
      </template>
<!--       <template v-else>
        <p>По коду: {{value}} ничего не найдено</p>
      </template> -->
      

    
<!--     <v-btn @click="sound_success">success</v-btn>
    <v-btn @click="sound_fail">fail</v-btn> -->
  </div>

</template>

<script>
import { fixBarcode} from '../js/fixBarcode.js';

export default {
  data(){
    return {
      num:0, // для отложенного ajax-а
      value:'', // код для поиска
      list:[
        /*{type:'order',id:1},
        {type:'box',num_place:'76176276', id:1},*/
      ],
      sounds: {
          success: null,
          fail: null,
      },
      success: false, // сообщение об успешном добавлении
      accept_all_error: '', // сообщение об ошибке при добавлении "пропикиваний"

    }
  },
  created(){
    let t=this
    t.sounds.success = new Audio('/delivery/success.ogg');
    t.sounds.fail = new Audio('/delivery/fail.ogg');
  },
  methods:{
    sound_success(){
      this.sounds.success.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.success.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    sound_fail(){
      this.sounds.fail.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.fail.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    delete_from_list(idx){
      // удаляет из списка позицию
      this.list.splice(idx,1)
    },
    accept_all(){ // отравляется в приёмку накликанный список
      let t=this

      if(t.list.length){
          t.$http.post(
            BackendBase+'/delivery/first-app/accept-all',
            {
              list:t.list
            }
          ).then(
            r=>{
              let d=r.data
              if(d.success){
                t.success=true
                setTimeout(
                  ()=>{
                    t.list=[]
                    t.success=false
                  },900
                )
              }
              else if(d.error){
                t.accept_all_error=d.error
                setTimeout(
                  ()=>{
                    t.accept_all_error=false
                  },900
                )
              }
            }
          )
      }
    },
    check_code(){
      let t=this
      t.value=t.value.replace(/\s+/,'').replace(/\s+$/,'')
      if(!t.value){
        return 
      }
      t.num++

      setTimeout(
        ()=>{
          t.num--
          if(!t.num){ // поиск 
            t.$http.post(BackendBase+'/delivery/first-app',{
              value: t.value
            }).then(
              r=>{
                let d=r.data
                
                if(d.success){
                  t.value=''
                  if(d.list.length){
                    for(let o of d.list){ // что-то нашли, пополняем список
                      t.list.push(o)
                    }
                    t.sound_success()
                  }
                  else{
                    t.sound_fail()
                  }
                }
              }
            )
          }
        },
        300
      )
    }
  },
  watch:{
    value(){
      if(this.value){
        this.value=fixBarcode(this.value)
      }
    }
  }
}
</script>

<style scoped>
  .is_headapp {margin: 20px; max-width: 1400px;}
  .is_headapp h1 {margin-bottom: 20px;} 
  .order, .box {border: 1px solid gray; padding: 20px; margin-bottom: 20px; border-radius: 15px;  font-weight: bold;}
  .order {background-color: #3f674a;}
  .box {background-color: #71be86;}
  td.actions {width: 0px;}
</style>